import styled from '@emotion/styled';

import { LinearProgress } from '@pricemoov/pollux-react';

import logo from 'redesign/images/logo.svg';

interface SuspensePageFallbackProps {
    withLogo?: boolean;
}
const StyledLogo = styled.img`
    width: 150px;
`;

function SuspensePageFallback({ withLogo }: SuspensePageFallbackProps) {
    return (
        <div className="polx-flex polx-flex-col polx-items-center polx-justify-center polx-h-full polx-w-full">
            {withLogo ? <StyledLogo className="polx-mb-6" src={logo} alt="logo" /> : null}
            <LinearProgress variant="indeterminate" className="polx-w-1/5" />
        </div>
    );
}

export default SuspensePageFallback;
